
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bimi-logo-validator",
      function () {
        return require("private-next-pages/bimi-logo-validator.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bimi-logo-validator"])
      });
    }
  